import React from "react";
import { Button } from "@mui/material";

let coloursArr = [
  "bg-aqua-1 text-gray-1",
  "bg-aqua-2 text-gray-1",
  "bg-aqua-3 text-gray-1",
  "bg-aqua-4 text-gray-1",
  "bg-aqua-5 text-gray-1",
  "bg-aqua-6 text-gray-1",
  "bg-aqua-7 text-gray-1",
  "bg-aqua-8 text-gray-1",
  "bg-aqua-9 text-gray-1",
  "bg-coral-1 text-gray-1",
  "bg-coral-2 text-gray-1",
  "bg-coral-3 text-gray-1",
  "bg-coral-4 text-gray-1",
  "bg-coral-5 text-gray-1",
  "bg-coral-6 text-gray-1",
  "bg-coral-7 text-gray-1",
  "bg-mustard-1 text-gray-1",
  "bg-mustard-2 text-gray-1",
  "bg-gray-1 text-gray-1",
  "bg-gray-2 text-gray-1",
  "bg-gray-3 text-gray-1",
  "bg-gray-4 text-gray-1",
];

const ColoursEx = () => {
  return (
    <div>
      {coloursArr.map((item) => (
        <Button fullWidth className={item}>
          {item}
        </Button>
      ))}
    </div>
  );
};

export default ColoursEx;
